<script setup>
import { CAMPAIGN_CONFIG } from '../config.js'
import { useNextVoteText } from '../composables/nextVoteText'
import { useMysterySoundGuessStore } from '../stores/mysterySoundGuess'
import { storeToRefs } from 'pinia'

const { copy } = CAMPAIGN_CONFIG
const { nextVoteText } = useNextVoteText()

const mysterySoundGuess = useMysterySoundGuessStore()
const { name } = storeToRefs(mysterySoundGuess)
</script>

<template>
  <!-- eslint-disable-next-line vue/no-v-html -->
  <div class="text-xl text-white" v-html="copy.incorrect(name, nextVoteText)" />
</template>
